import type { Optional } from '@festina-life/core'
import cx from 'classnames'
import { type MouseEvent, type ReactNode, useCallback, useRef } from 'react'

import type { FPlusExpressionValue } from '../../types/templateModel'
import { EditorButtonGroup } from '../editorButtonGroup/EditorButtonGroup'

const MINIMUM_EDITOR_HEIGHT = 16

type Props = {
  code: string
  onChangeCode?: Optional<(nextValue: FPlusExpressionValue) => void>
  onCancel: () => void
  initialHeightPx: number
  children: ReactNode
  className?: string
}

export const FPlusInlineEditContainer = ({
  children,
  onCancel,
  onChangeCode,
  initialHeightPx,
  className,
  code,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const initialHeight = useRef(initialHeightPx)

  const handleCancel = useCallback(
    (mouseEvent?: MouseEvent) => {
      if (mouseEvent) {
        mouseEvent.stopPropagation()
      }
      onCancel()
    },
    [onCancel],
  )
  const onSave = useCallback(
    (mouseEvent?: MouseEvent) => {
      if (mouseEvent) {
        mouseEvent.stopPropagation()
      }

      if (onChangeCode) {
        onChangeCode({ fplusSource: code })
      }
    },
    [code, onChangeCode],
  )

  return (
    <div
      className={cx('relative size-full overflow-visible', className)}
      ref={containerRef}
      style={{
        minHeight: `${Math.max(initialHeight.current, MINIMUM_EDITOR_HEIGHT)}px`,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
      <EditorButtonGroup
        onCancel={handleCancel}
        onSave={onSave}
        className="bottom-2 right-2 z-10 mt-2"
      />
    </div>
  )
}
